// src/components/Logs/LogForenseFilter.js
import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  TextField,
  Button,
  Box
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

const LogForenseFilter = ({ filtros, onChange, onApply }) => {
  const handleChange = (field) => (event) => {
    onChange({
      ...filtros,
      [field]: event.target.value
    });
  };

  const handleDateChange = (field) => (date) => {
    onChange({
      ...filtros,
      [field]: date
    });
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={6} md={3}>
        <DatePicker
          label="Data Início"
          value={filtros.dataInicio}
          onChange={handleDateChange('dataInicio')}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <DatePicker
          label="Data Fim"
          value={filtros.dataFim}
          onChange={handleDateChange('dataFim')}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          fullWidth
          label="Ação"
          value={filtros.acao}
          onChange={handleChange('acao')}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Box display="flex" gap={1}>
          <Button
            variant="contained"
            color="primary"
            onClick={onApply}
            fullWidth
          >
            Aplicar
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              onChange({
                dataInicio: null,
                dataFim: null,
                acao: '',
                usuarioId: ''
              });
              onApply();
            }}
            fullWidth
          >
            Limpar
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

LogForenseFilter.propTypes = {
    filtros: PropTypes.shape({
      dataInicio: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
        PropTypes.object
      ]),
      dataFim: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
        PropTypes.object
      ]),
      acao: PropTypes.string,
      usuarioId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ])
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onApply: PropTypes.func.isRequired
  };
  
  LogForenseFilter.defaultProps = {
    filtros: {
      dataInicio: null,
      dataFim: null,
      acao: '',
      usuarioId: ''
    }
  };
  


export default LogForenseFilter;